import { BaseEntity, EntityDateInfo, IdType } from '@rootCommon/types/common';

export interface BrandingFileDto {
  fileId: IdType;
  organizationId?: IdType;
}

export interface BrandingFile extends Omit<BrandingFileDto, 'organizationId'>, BaseEntity, EntityDateInfo {
  fileName: 'string';
}

export enum BrandingRecords {
  emailLogoBrandingRecordId = 'emailLogoBrandingRecordId',
  primaryLogoBrandingRecordId = 'primaryLogoBrandingRecordId',
}

export enum LogoRepositories {
  primaryLogoFileId = 'primaryLogoFileId',
  emailLogoFileId = 'emailLogoFileId',
}

export enum LogoRepositoryRoute{
  ADMIN = 'admin',
  CONTROL = 'control',
}
export interface DashboardBrandingDto {
  [BrandingRecords.primaryLogoBrandingRecordId]: IdType | null;
}

export interface DashboardBranding extends BaseEntity, EntityDateInfo {
  [LogoRepositories.primaryLogoFileId]: IdType | null;
}

export interface FhqBrandingDto {
  [BrandingRecords.primaryLogoBrandingRecordId]: IdType | null;
  [BrandingRecords.emailLogoBrandingRecordId]: IdType | null;
}

export interface FhqBranding extends BaseEntity, EntityDateInfo {
  [LogoRepositories.primaryLogoFileId]: IdType | null;
  [LogoRepositories.emailLogoFileId]: IdType | null;
}
